/* Load synchronously in <head>, before content_for_header, on employment pages. */
(function () {
  'use strict';

  if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:trabajo|pages\/(?:trabajo|trabaja-con-nosotros|puestos-especiales))\/?$/i.test(window.location.pathname)) return;

  var html = document.documentElement;
  if (html.hasAttribute('data-tb-careers-commercial-guard')) return;
  html.setAttribute('data-tb-careers-commercial-guard', 'true');

  var roots = [
    '[data-condor-checkout-directo]',
    '[data-condor-combo]',
    '[data-condor-delivery]',
    '[data-condor-despacho]',
    '[data-condor-en-vivo]',
    '[data-condor-journey]',
    '[data-condor-mision]',
    '[data-condor-oferta-audio]',
    '[data-condor-quick-buy]',
    '[data-condor-ruleta]',
    '[data-condor-upsell]',
    '[data-condor-urgencia]'
  ].join(',');

  function removeCommercialRoots(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(roots)) {
      node.remove();
      return;
    }
    node.querySelectorAll(roots).forEach(function (root) { root.remove(); });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(removeCommercialRoots);
    });
  });
  observer.observe(html, { childList: true, subtree: true });
  removeCommercialRoots(html);

  // Defer the visible alias until deferred store scripts have checked the native path.
  function showPublicAddress() {
    try {
      var cleanUrl = new URL(window.location.href);
      if (/^\/(?:pages\/(?:trabajo|trabaja-con-nosotros)|trabajo)\/?$/i.test(cleanUrl.pathname)) {
        cleanUrl.pathname = '/trabajo';
        cleanUrl.searchParams.delete('actualizado');
        if (cleanUrl.href !== window.location.href) {
          window.history.replaceState(window.history.state, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
        }
      }
    } catch (error) {
      // Commercial guards remain active if a browser restricts history updates.
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showPublicAddress, { once: true });
  } else {
    showPublicAddress();
  }
})();
